import { IIntervalFormat, IIntervalType } from '../types';

export const Intervals: IIntervalType[] = [
  {
    name: 'Без повторений',
    value: 'WITHOUT_REPEAT',
  },
  {
    name: 'Ежемесячно',
    value: 'MONTHLY',
  },
  {
    name: 'Еженедельно',
    value: 'WEEKLY',
  },
  {
    name: 'Ежедневно',
    value: 'DAILY',
  },
  {
    name: 'По будним дням',
    value: 'EVERY_WORKDAY',
  },
  {
    name: 'Другое',
    value: 'ANOTHER',
  },
];

export const IntervalFormats: IIntervalFormat[] = [
  {
    forms: ['день','дня','дней'],
    value: 'DAY',
  },
  {
    forms: ['неделя','недели','недель'],
    value: 'WEEK',
  },
  {
    forms: ['месяц','месяца','месяцев'],
    value: 'MONTH',
  },
];
